import Vue from 'vue';
import moment from 'moment';
import purchaseList from '../console-common/table.vue';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'violationPurchaseRecord',
    components: {
        'el-purchase-record-list': purchaseList,
    },
    data: function () {
        return {
            form: {
                status: '',
                date: '',
            },
            otherParam: {},
            preFilledParam: {},
            isClearOtherParam: true,
            statusList: [
                {
                    label: '购买成功',
                    val: 'SUCCESS',
                },
                {
                    label: '购买中',
                    val: 'PURCHASING',
                },
                {
                    label: '购买失败',
                    val: 'FAIL',
                },
            ],
            tableConfig: [
                {
                    prop: 'purchaseTime',
                    label: '购买时间',
                    formatter: function (purchaseTime) {
                        return moment(purchaseTime).format('YYYY-MM-DD HH:mm');
                    },
                },
                {
                    prop: 'type',
                    label: '购买方式',
                    formatter: function (purchaseType) {
                        var purchaseTypes = {
                            BALANCE: '余额支付',
                            OFFLINE: '线下汇款',
                            SCAN_CODE_PAY: '扫码支付',
                        };
                        return purchaseTypes[purchaseType];
                    },
                },
                {
                    prop: 'amount',
                    label: '金额（元）',
                    formatter: function (amount) {
                        return toYuan(amount);
                    },
                },
                {
                    prop: 'times',
                    label: '购买数量（条）',
                },
                {
                    prop: 'status',
                    label: '订单状态',
                    formatter: function (status) {
                        var statusList = {
                            SUCCESS: '购买成功',
                            PURCHASING: '购买中',
                            FAIL: '购买失败',
                        };
                        return statusList[status];
                    },
                },
                {
                    prop: 'purchaseCode',
                    label: '订单号',
                },
            ],
            cellConfig: {
                status: [
                    {
                        status: 'FAIL',
                        style: 'color:#FF5257',
                    },
                ],
            },
            requestConfig: {
                url: '/proxy/violation/purchase/page',
                method: 'post',
            },
        };
    },
    created: function () {
        this.$store.commit('common/update', {
            commonBread: Object.assign({}, {
                prewRouterName: 'violationQuery',
                prewName: '违章查询',
                currentName: '购买查询次数',
            }),
        });
        this.initPreFilledParam();
    },
    methods: {
        initPreFilledParam: function () {
            var params = this.$route.params;
            for (var item in params) {
                this.preFilledParam[item] = params[item];
            }
        },
        statusSelectMain: function () {
            this.orderStatus = '';
        },
        getData: function () {
            var _a = this.form, showStatus = _a.showStatus, date = _a.date;
            var startTime = '';
            var endTime = '';
            if (date) {
                startTime = moment(date[0]).format('YYYY-MM-DD');
                endTime = moment(date[1]).format('YYYY-MM-DD');
            }
            this.otherParam = Object.assign({}, {
                startTime: startTime,
                endTime: endTime,
                showStatus: showStatus,
            });
        },
    },
});
